import { StyleSheet, View } from 'react-native';

import { Skeleton, Text } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';
import { CHECKOUT_ORDER_SUMMARY_TAX } from '@fhs-legacy/frontend/src/utils/test-ids';

import { checkoutFocusableLabeledProps } from '../../checkout-a11y';

function TaxRow() {
  const { serverOrder, serverOrderLoading } = useCartContext();
  const enableZeroPricedOrder = useFlag('enable-zero-cart-total-order');

  const taxCents = serverOrder?.cart?.taxCents || 0;

  if (serverOrderLoading || !serverOrder?.cart || (!enableZeroPricedOrder && taxCents === 0)) {
    return (
      <View
        testID={CHECKOUT_ORDER_SUMMARY_TAX}
        style={styles.container}
        {...checkoutFocusableLabeledProps('Tax, loading')}
      >
        <Text.Paragraph size="sm">Tax</Text.Paragraph>
        <Skeleton style={styles.skeleton} />
      </View>
    );
  }

  const taxA11y = `Tax, $${(taxCents / 100).toFixed(2)}`;

  return (
    <View testID={CHECKOUT_ORDER_SUMMARY_TAX} style={styles.container} {...checkoutFocusableLabeledProps(taxA11y)}>
      <Text.Paragraph size="sm">Tax</Text.Paragraph>
      <Text.Paragraph size="sm">${(taxCents / 100).toFixed(2)}</Text.Paragraph>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 4,
    marginHorizontal: 28,
  },
  skeleton: {
    height: 16,
    width: 48,
    borderRadius: 4,
  },
});

export default TaxRow;
